/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9.5 2.5 17.5 2.5 17.5 5" />
      <polyline points="17.5 20 17.5 21.5 9.5 21.5" />
      <polygon points="0.5 21.5 9.5 23.5 9.5 0.5 0.5 2.5" />
      <circle cx="6" cy="12.5" r="1.5" />
      <g transform="translate(12.000000, 8.000000)">
        <path d="M0,4.508 L11.5,4.508" />
        <polyline points="7.5 0.5 11.5 4.5 7.5 8.5" />
      </g>
    </g>
  </svg>
);

export default Icon;
